export type HeaderType = 'holiday' | 'new-year' | 'regular'

// 9:00 AM JST on Dec 26, 2025
const NEW_YEAR_START = new Date('2025-12-26T09:00:00+09:00')
// 9:00 AM JST on Jan 5, 2026
const NEW_YEAR_END = new Date('2026-01-05T09:00:00+09:00')

/**
 * Determines which header type to use based on the current time in JST timezone.
 * - Before 12/26 9:00AM JST → 'holiday'
 * - From 12/26 9:00AM JST to 1/5 9:00AM JST → 'new-year'
 * - After 1/5 9:00AM JST → 'regular'
 */
export function getHeaderType(): HeaderType {
  const now = new Date()

  if (now < NEW_YEAR_START) {
    return 'holiday'
  } else if (now < NEW_YEAR_END) {
    return 'new-year'
  } else {
    return 'regular'
  }
}
